import axios from "axios";

const API_URL =
  typeof window === "object"
    ? window.location.origin.search("staging") !== -1
      ? "https://bot.paradigma.education/"
      : "https://bot.paradigma.education/"
    : null;

const api = axios.create({
  baseURL:
    window.location.origin.search("localhost") === -1
      ? API_URL
      : "https://bot.paradigma.education/",
});

export default api;
